/* eslint-disable */
// THIS FILE IS GENERATED — DO NOT EDIT.
// Source: contracts/admin.v1.graphql (frozen Phase 0 baseline).
// Regenerate with `npm run codegen`.
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type ApiKey = {
  __typename?: 'ApiKey';
  application: Application;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedKey: Scalars['String']['output'];
  overrideMode: OverrideMode;
  pinnedProvider?: Maybe<ProviderType>;
  scopes: Array<Scalars['String']['output']>;
  status: ApiKeyStatus;
};

export enum ApiKeyStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export enum AppEnvironment {
  Development = 'DEVELOPMENT',
  Production = 'PRODUCTION',
  Staging = 'STAGING'
}

export type Application = {
  __typename?: 'Application';
  apiKeys: Array<ApiKey>;
  client: Client;
  environment: AppEnvironment;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  action: Scalars['String']['output'];
  actor: Scalars['String']['output'];
  changes?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  targetId?: Maybe<Scalars['ID']['output']>;
  targetType: Scalars['String']['output'];
};

export type AuditLogEntryConnection = {
  __typename?: 'AuditLogEntryConnection';
  edges: Array<AuditLogEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditLogEntryEdge = {
  __typename?: 'AuditLogEntryEdge';
  cursor: Scalars['String']['output'];
  node: AuditLogEntry;
};

export type CanonicalModel = {
  __typename?: 'CanonicalModel';
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  kind: CanonicalModelKind;
  name: Scalars['String']['output'];
  providerCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CanonicalModelKind {
  Auto = 'AUTO',
  Custom = 'CUSTOM',
  Upstream = 'UPSTREAM'
}

export type Client = {
  __typename?: 'Client';
  applications: Array<Application>;
  dataResidency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  status: ClientStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientQuota = {
  __typename?: 'ClientQuota';
  clientId: Scalars['ID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  enforcementMode: QuotaEnforcementMode;
  id: Scalars['ID']['output'];
  monthlyRequestCap?: Maybe<Scalars['Int']['output']>;
  monthlyTokenCap?: Maybe<Scalars['Int']['output']>;
};

export type ClientQuotaReportRow = {
  __typename?: 'ClientQuotaReportRow';
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  completionTokens: Scalars['Int']['output'];
  enforcementMode?: Maybe<QuotaEnforcementMode>;
  month: Scalars['String']['output'];
  monthlyRequestCap?: Maybe<Scalars['Int']['output']>;
  monthlyTokenCap?: Maybe<Scalars['Int']['output']>;
  overRequestCap: Scalars['Boolean']['output'];
  overTokenCap: Scalars['Boolean']['output'];
  promptTokens: Scalars['Int']['output'];
  reasoningTokens: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export enum ClientStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Suspended = 'SUSPENDED'
}

export type CreateApiKeyInput = {
  applicationId: Scalars['ID']['input'];
  overrideMode?: InputMaybe<OverrideMode>;
  pinnedProvider?: InputMaybe<ProviderType>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  apiKey: ApiKey;
  rawKey: Scalars['String']['output'];
};

export type CreateApplicationInput = {
  clientId: Scalars['ID']['input'];
  environment: AppEnvironment;
  name: Scalars['String']['input'];
};

export type CreateCanonicalModelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateClientInput = {
  dataResidency?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type HealthEvent = {
  __typename?: 'HealthEvent';
  at: Scalars['DateTime']['output'];
  latencyMs?: Maybe<Scalars['Int']['output']>;
  outcome: HealthEventOutcome;
  reason?: Maybe<Scalars['String']['output']>;
  source: HealthEventSource;
  statusCode?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum HealthEventOutcome {
  Failed = 'FAILED',
  Ok = 'OK'
}

export enum HealthEventSource {
  Live = 'LIVE',
  Probe = 'PROBE'
}

export enum HealthState {
  Degraded = 'DEGRADED',
  Down = 'DOWN',
  Healthy = 'HEALTHY'
}

export type Heartbeat = {
  __typename?: 'Heartbeat';
  at: Scalars['DateTime']['output'];
};

export type ModelAlias = {
  __typename?: 'ModelAlias';
  canonicalModel: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  provider: Provider;
  providerModel: Scalars['String']['output'];
  wildcard: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  archiveProvider: Provider;
  createApiKey: CreateApiKeyResult;
  createApplication: Application;
  createCanonicalModel: CanonicalModel;
  createClient: Client;
  deleteCanonicalModel: Scalars['Boolean']['output'];
  deleteClientQuota: Scalars['Boolean']['output'];
  deleteModelAlias: Scalars['Boolean']['output'];
  deleteQuota: Scalars['Boolean']['output'];
  deleteRoutingPolicy: Scalars['Boolean']['output'];
  probeProvider: ProviderProbeResult;
  refreshProviderModels: RefreshModelsSummary;
  resetProviderHealth: Provider;
  revokeApiKey: ApiKey;
  rotateApiKey: CreateApiKeyResult;
  setApiKeyOverride: ApiKey;
  setLogContent: SystemSettings;
  setProviderDefaultModel: Provider;
  setProviderEnabled: Provider;
  unarchiveProvider: Provider;
  updateCanonicalModel: CanonicalModel;
  updateClientStatus: Client;
  upsertClientQuota: ClientQuota;
  upsertModelAlias: ModelAlias;
  upsertProvider: Provider;
  upsertQuota: Quota;
  upsertRoutingPolicy: RoutingPolicy;
};


export type MutationArchiveProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateCanonicalModelArgs = {
  input: CreateCanonicalModelInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationDeleteCanonicalModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientQuotaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteModelAliasArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuotaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoutingPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProbeProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefreshProviderModelsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetProviderHealthArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRotateApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetApiKeyOverrideArgs = {
  id: Scalars['ID']['input'];
  overrideMode: OverrideMode;
  pinnedProvider?: InputMaybe<ProviderType>;
};


export type MutationSetLogContentArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetProviderDefaultModelArgs = {
  canonicalModelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSetProviderEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateCanonicalModelArgs = {
  input: UpdateCanonicalModelInput;
};


export type MutationUpdateClientStatusArgs = {
  id: Scalars['ID']['input'];
  status: ClientStatus;
};


export type MutationUpsertClientQuotaArgs = {
  input: UpsertClientQuotaInput;
};


export type MutationUpsertModelAliasArgs = {
  input: UpsertModelAliasInput;
};


export type MutationUpsertProviderArgs = {
  input: UpsertProviderInput;
};


export type MutationUpsertQuotaArgs = {
  input: UpsertQuotaInput;
};


export type MutationUpsertRoutingPolicyArgs = {
  input: UpsertRoutingPolicyInput;
};

export enum OverrideMode {
  Auto = 'AUTO',
  ForceExternal = 'FORCE_EXTERNAL',
  ForceInternal = 'FORCE_INTERNAL',
  Pin = 'PIN'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum ProbeStatus {
  AuthFailed = 'AUTH_FAILED',
  InvalidResponse = 'INVALID_RESPONSE',
  ModelMismatch = 'MODEL_MISMATCH',
  NoCredentials = 'NO_CREDENTIALS',
  Ok = 'OK',
  Unreachable = 'UNREACHABLE'
}

export type Provider = {
  __typename?: 'Provider';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  baseUrl: Scalars['String']['output'];
  credentialsRef?: Maybe<Scalars['String']['output']>;
  dataResidency?: Maybe<Scalars['String']['output']>;
  defaultCanonicalModel?: Maybe<CanonicalModel>;
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  health: ProviderHealth;
  id: Scalars['ID']['output'];
  maxConcurrency: Scalars['Int']['output'];
  metrics24h?: Maybe<ProviderMetrics24h>;
  modelAliases: Array<ModelAlias>;
  probePath?: Maybe<Scalars['String']['output']>;
  recentHealthEvents: Array<HealthEvent>;
  type: ProviderType;
  weight: Scalars['Int']['output'];
};

export type ProviderHealth = {
  __typename?: 'ProviderHealth';
  consecutiveFailures: Scalars['Int']['output'];
  inFlight: Scalars['Int']['output'];
  lastProbeAt?: Maybe<Scalars['DateTime']['output']>;
  state: HealthState;
};

export type ProviderMetrics24h = {
  __typename?: 'ProviderMetrics24h';
  avgLatencyMs?: Maybe<Scalars['Float']['output']>;
  errorCount: Scalars['Int']['output'];
  errorRate?: Maybe<Scalars['Float']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  requestCount: Scalars['Int']['output'];
};

export type ProviderProbeResult = {
  __typename?: 'ProviderProbeResult';
  checkedAt: Scalars['DateTime']['output'];
  latencyMs?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  provider: Provider;
  status: ProbeStatus;
};

export enum ProviderType {
  Anthropic = 'ANTHROPIC',
  Gemini = 'GEMINI',
  InHouse = 'IN_HOUSE',
  Openai = 'OPENAI',
  Openrouter = 'OPENROUTER'
}

export type ProviderUpstreamModels = {
  __typename?: 'ProviderUpstreamModels';
  models: Array<UpstreamModel>;
  probedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: Provider;
};

export type ProviderUsageBucket = {
  __typename?: 'ProviderUsageBucket';
  failureRate: Scalars['Float']['output'];
  provider: ProviderType;
  requests: Scalars['Int']['output'];
  tokens: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  apiKey?: Maybe<ApiKey>;
  application?: Maybe<Application>;
  auditLog: AuditLogEntryConnection;
  canonicalModel?: Maybe<CanonicalModel>;
  canonicalModels: Array<CanonicalModel>;
  client?: Maybe<Client>;
  clientQuotaReport: Array<ClientQuotaReportRow>;
  clientQuotas: Array<ClientQuota>;
  clients: Array<Client>;
  provider?: Maybe<Provider>;
  providerUpstreamModels: ProviderUpstreamModels;
  providers: Array<Provider>;
  quotas: Array<Quota>;
  routingPolicies: Array<RoutingPolicy>;
  simulateRoute: RouteSimulation;
  systemSettings: SystemSettings;
  usageRecords: UsageRecordConnection;
  usageSummary: UsageSummary;
};


export type QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCanonicalModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanonicalModelsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<CanonicalModelKind>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientQuotaReportArgs = {
  month: Scalars['String']['input'];
};


export type QueryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProviderUpstreamModelsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProvidersArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuotasArgs = {
  scope?: InputMaybe<QuotaScope>;
  scopeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySimulateRouteArgs = {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  canonicalModel: Scalars['String']['input'];
};


export type QueryUsageRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsageSummaryArgs = {
  filter?: InputMaybe<UsageFilter>;
};

export type Quota = {
  __typename?: 'Quota';
  dailyTokenCap?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  maxConcurrency?: Maybe<Scalars['Int']['output']>;
  rpm?: Maybe<Scalars['Int']['output']>;
  scope: QuotaScope;
  scopeId: Scalars['ID']['output'];
  scopeName?: Maybe<Scalars['String']['output']>;
  tpm?: Maybe<Scalars['Int']['output']>;
};

export enum QuotaEnforcementMode {
  Block = 'BLOCK',
  Warn = 'WARN'
}

export enum QuotaScope {
  App = 'APP',
  Client = 'CLIENT',
  Key = 'KEY'
}

export type RefreshModelsSummary = {
  __typename?: 'RefreshModelsSummary';
  added: Array<Scalars['String']['output']>;
  aliased: Array<Scalars['String']['output']>;
  existing: Array<Scalars['String']['output']>;
  unchanged: Array<Scalars['String']['output']>;
};

export enum RequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type RouteCandidate = {
  __typename?: 'RouteCandidate';
  eligible: Scalars['Boolean']['output'];
  exclusionReason?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  provider: Provider;
  providerModel?: Maybe<Scalars['String']['output']>;
};

export type RouteSimulation = {
  __typename?: 'RouteSimulation';
  candidates: Array<RouteCandidate>;
  checkedAt: Scalars['DateTime']['output'];
  policy?: Maybe<RoutingPolicy>;
  routedReason?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<RouteCandidate>;
  status: RouteSimulationStatus;
};

export enum RouteSimulationStatus {
  NoEligibleProvider = 'NO_ELIGIBLE_PROVIDER',
  NoPolicy = 'NO_POLICY',
  Ok = 'OK'
}

export enum RoutedReason {
  Overflow = 'OVERFLOW',
  Override = 'OVERRIDE',
  Preferred = 'PREFERRED',
  RetryFallback = 'RETRY_FALLBACK',
  UnhealthyFailover = 'UNHEALTHY_FAILOVER'
}

export type RoutingPolicy = {
  __typename?: 'RoutingPolicy';
  capacityThreshold?: Maybe<Scalars['Float']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  providerOrder: Array<ProviderType>;
  scopeApplication?: Maybe<Application>;
  scopeCanonicalModel?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  providerHealthChanged: Provider;
  systemHeartbeat: Heartbeat;
  usageRecorded: UsageRecord;
};


export type SubscriptionUsageRecordedArgs = {
  filter?: InputMaybe<UsageFilter>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  logContent: Scalars['Boolean']['output'];
};

export type UpdateCanonicalModelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertClientQuotaInput = {
  clientId: Scalars['ID']['input'];
  enforcementMode?: InputMaybe<QuotaEnforcementMode>;
  id?: InputMaybe<Scalars['ID']['input']>;
  monthlyRequestCap?: InputMaybe<Scalars['Int']['input']>;
  monthlyTokenCap?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertModelAliasInput = {
  canonicalModel?: InputMaybe<Scalars['String']['input']>;
  canonicalModelId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerModel: Scalars['String']['input'];
  wildcard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertProviderInput = {
  baseUrl: Scalars['String']['input'];
  credentialsRef?: InputMaybe<Scalars['String']['input']>;
  dataResidency?: InputMaybe<Scalars['String']['input']>;
  defaultCanonicalModelId?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxConcurrency?: InputMaybe<Scalars['Int']['input']>;
  probePath?: InputMaybe<Scalars['String']['input']>;
  type: ProviderType;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertQuotaInput = {
  dailyTokenCap?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxConcurrency?: InputMaybe<Scalars['Int']['input']>;
  rpm?: InputMaybe<Scalars['Int']['input']>;
  scope: QuotaScope;
  scopeId: Scalars['ID']['input'];
  tpm?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertRoutingPolicyInput = {
  capacityThreshold?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  providerOrder: Array<ProviderType>;
  scopeApplicationId?: InputMaybe<Scalars['ID']['input']>;
  scopeCanonicalModel?: InputMaybe<Scalars['String']['input']>;
};

export type UpstreamModel = {
  __typename?: 'UpstreamModel';
  aliasedAs: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type UsageFilter = {
  apiKeyId?: InputMaybe<Scalars['ID']['input']>;
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  canonicalModel?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  provider?: InputMaybe<ProviderType>;
  status?: InputMaybe<RequestStatus>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UsageRecord = {
  __typename?: 'UsageRecord';
  actualProviderModel?: Maybe<Scalars['String']['output']>;
  apiKey: ApiKey;
  application: Application;
  canonicalModel: Scalars['String']['output'];
  chosenProvider: ProviderType;
  client: Client;
  completionTokens: Scalars['Int']['output'];
  costEstimate?: Maybe<Scalars['Float']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  policyId?: Maybe<Scalars['ID']['output']>;
  policyName?: Maybe<Scalars['String']['output']>;
  promptTokens: Scalars['Int']['output'];
  providerModel: Scalars['String']['output'];
  proxyRequest?: Maybe<Scalars['JSON']['output']>;
  proxyResponse?: Maybe<Scalars['JSON']['output']>;
  queueMs: Scalars['Int']['output'];
  reasoningTokens: Scalars['Int']['output'];
  routedReason: RoutedReason;
  routingDecision?: Maybe<Scalars['JSON']['output']>;
  status: RequestStatus;
  streamed: Scalars['Boolean']['output'];
  totalMs: Scalars['Int']['output'];
  upstreamMs: Scalars['Int']['output'];
  upstreamRequest?: Maybe<Scalars['JSON']['output']>;
  upstreamResponse?: Maybe<Scalars['JSON']['output']>;
};

export type UsageRecordConnection = {
  __typename?: 'UsageRecordConnection';
  edges: Array<UsageRecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsageRecordEdge = {
  __typename?: 'UsageRecordEdge';
  cursor: Scalars['String']['output'];
  node: UsageRecord;
};

export type UsageSummary = {
  __typename?: 'UsageSummary';
  byProvider: Array<ProviderUsageBucket>;
  totalCostEstimate?: Maybe<Scalars['Float']['output']>;
  totalRequests: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};
